export const tableQueryKeys = {
  group: "group",
  chatReason: "chat-reason",
  channel: "channel",
  tag: "tag",
  orders: "orders",
  stores: "stores",
  users:"users",
  agents:"users/agents",
  customers:"customers",
  storeAreas: (storeId: string) =>`stores/areas/${storeId}`,
  region: "company/region",
  area: "company/area",
  orderStatus: "company/order-status",
  orderStatusGroup: "company/order-status-group",
  orderTracks: (id: string) => `orders/track/${id}`,
  callChannels: "company/call-channels",
  deliveryTime: "company/delivery-time",
  loyaltySettings: "company/loyalty-settings",
  paymentSettings: "company/payment-settings",
  invoiceLinkSettings: "company/invoice-link-settings",
  company: "company",
  activities: "activities",
  activitiesTrack: (id: any) =>`activities/track/${id}`,
  activityStatus: "activities/status",
  activityPriority: "activities/priority",
  activityTypes: "activities/type",
  activitySections: "activities/section",
  activityReasons: "activities/reason",
  inquiry: "activities/inquiry",
  complaint: "activities/complaint",
  companies: "company/admin",
  companyLoginAs: (id: any) => `company/admin/login-as/${id}`,
  customizationPresets: "company/admin/customizations/presets",
  customizationPreset: (id: string | number) =>
    `company/admin/customizations/presets/${id}`,
  customizationAssignments: "company/admin/customizations/assignments",
  customizationAssignment: (id: string | number) =>
    `company/admin/customizations/assignments/${id}`,
  customizationCompanyModule: (
    companyId: string | number,
    moduleName: string
  ) =>
    `company/admin/customizations/companies/${companyId}/modules/${moduleName}`,

  // Custom Views (per-user column visibility). `view` is currently "orders" | "categories" —
  // the backend has no endpoint to list available views, so this isn't derived dynamically.
  customViewsAvailableColumns: (view: string) =>
    `custom-views/${view}/available-columns`,
  customViewsMine: (view: string) => `custom-views/${view}`,
  customViewsUser: (userId: string | number, view: string) =>
    `custom-views/users/${userId}/${view}`,

  models: "company/models",
  assignedModels: "company/models/assigned",
  permissions: "company/permissions",
  sliders: "sliders",
  sliderTypes: "sliders/types",
  flashDeals: "flash-deals",
  flashDealsBulkDelete: "flash-deals/bulk",
  products: "products",
  productsBulkDelete: "products/bulk",
  productsBulkStatus: "products/bulk/status",
  productsBulkManufacturer: "products/bulk/manufacturer",
  categories: "categories",
  categoriesBulkDelete: "categories/bulk",
  allCategories: "categories/all",
  brands: "brands",
  brandsBulkDelete: "brands/bulk",
  manufacturers: "manufacturers",
  manufacturersBulkDelete: "manufacturers/bulk",
  unitTypes: "products/units-types",
  extras: "extra",
  extrasBulkDelete: "extra/bulk",
  productAttributes: "product-attributes",
  productAttributesBulkDelete: "product-attributes/bulk",
  keywords: "keywords",
  productReviews: "product-reviews",
  reviewBannedWords: "review-banned-words",
  sections: "sections",
  roles: "roles",
  // Location tables
  countries: "countries",
  cities: "cities",
  areas: "areas",
  regions: "regions",
  regionsByArea: (areaId: string) => `regions/by-area/${areaId}`,
  offers: "offers",
  offersGroup: "offer-groups",
  cancelReasons: "cancel-reasons",
  uncompletedOrderReasons: "uncompleted-order-reasons",
  prescriptionStatuses: "prescription-statuses",
  prescriptionRejectReasons: "prescription-reject-reasons",
  prescriptionReviews: "prescription-reviews",
  refunds: "refunds",
  refundApprovalRules: "refund-approval-rules",
  homeStaticContents: "company/home-static-contents",
  homeBlocks: "home-blocks",
  blogs: "blogs",
  videos: "videos",
  symptoms: "symptoms",
  skills: "skills",
  serviceTypes: "service-types",
  tripTypes: "trip-types",
  shoppers: "shoppers",
  drivers: "drivers",
  shopperOrderStatus: "shoppers/order-statuses",
  segments: "segments",
  dmsDashboard: "dms/dashboard",
  dmsTop10: "dms/top-10",
  dmsTop10Shoppers: "dms/top-10-shoppers",
  dmsDriverTracker: "dms/driver-tracker",
  dmsAgentKPI: "dms/agent-kpi",
  dmsPrediction: "dms/prediction",
  dmsDrivers: "dms/drivers",
  dmsShoppers: "dms/shoppers",
  companyReport: "reports/company",
  reportDashboard: "reports/dashboard",
  collectorDeliveryPerformance: "reports/collector-delivery-performance",
  storeCompare: "reports/store-compare",
  growthReport: "reports/growth",
  productReport: "reports/products",
  customerReport: "reports/customers",
  orderAnalytics: "reports/order-analytics",
  revenueReport: "reports/revenue",
  productNotificationsFilter: "products/notifications/filter",
  productNotificationsReset: "products/notifications/reset",
  productNotify: "products/notify",
  insuranceCompanies: "insurance-companies",
  insuranceCompanyFiles: (companyId: string | number) =>
    `insurance-companies/${companyId}/files`,
  insuranceCompanyCoverages: (companyId: string | number) =>
    `insurance-companies/${companyId}/coverages`,
  shortLinks: "short-links",
  sallaOrders: "salla-orders",
  sallaPurchasedOrders: "salla-purchased-orders",
  sallaPurchaseOrder: (id: string) => `salla-orders/purchase/${id}`,
  sallaBulkPurchase: "salla-orders/bulk-purchase",
  sallaPurchasedOrderDetails: (id: string | number) => `salla-purchased-orders/${id}`,
  sallaPurchasedOrderPrint: (id: string | number) => `salla-purchased-orders/${id}/print`,
  suppliers: "suppliers",
  supplier: (id: string | number) => `suppliers/${id}`,
  shopperCustody: (shopperId: number | string) => `shoppers/${shopperId}/custody`,
  shopperCustodySummary: (shopperId: number | string) => `shoppers/${shopperId}/custody/summary`,
  promocodes: "promo-codes",
  promocodesBulkDelete: "promo-codes/bulk",
  emailSettings: "email-settings",
  smsTemplates: "integration/sms/templates",
  notifications: "notifications",
  organizations: "organizations",
  companyKeys: "company-keys",
  companyKeyTypes: "company-keys/types",

  // ── Purchasing (Purchases API) ───────────────────────────────────────
  purchasesLowStock: "purchases/low-stock-products",
  purchasesCreate: "purchases",
  purchasesBranchOrders: "purchases/orders",
  purchasesBranchOrder: (id: number | string) => `purchases/orders/${id}`,
  purchasesCompanyOrders: "purchases/company/orders",
  purchasesCompanyOrder: (id: number | string) => `purchases/company/orders/${id}`,
  purchasesChangeStatus: (status: 0 | 1 | 2, id: number | string) =>
    `purchases/changeStatus/${status}/${id}`,
};
